<template>
    <div class="pageHeaderBox">
      <h2 class="pageHeaderBox-title" v-html="value.title.value"></h2>
      <div class="pageHeaderBox-contain">
        <div class="pageHeaderBox-contain-group">
          <div class="pageHeaderBox-item-group" v-for="(item, index) in value.dataList" :key="index">
            <label>{{ item.text }}</label>
            <span>{{ item.value }}</span>
          </div>
        </div>
        <div class="pageHeaderBox-item-group" v-if="value.print !== undefined">
          <div class="mb-3">
            <label>{{ value.print.text == null ? "列印日期：" : value.print.text }}</label>
            <span>{{ value.print.value }}</span>
          </div>
          <div class="pageHeaderBox-item-printBtn" v-if="value.print.active === true">
            <DefaultButton :colorType="'primary'" @doFunction="doPrint">
              <span class="text__size-14">列印此表</span>
            </DefaultButton>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/button/DefaultButton.vue';

export default {
  name: 'PageHeaderBox',
  description: '頁面標題元件',
  components: {
    DefaultButton,
  },
  props: {
    value: {
      type: [Object],
    },
  },
  methods: {
    doPrint() {
      if (this.value.print.doFunction === undefined) {
        this.doDefaultPrint();
      } else {
        this.value.print.doFunction();
      }
    },
    doDefaultPrint() {
      // Get HTML to print from element
      const prtHtml = document.querySelector('.main').innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      // eslint-disable-next-line no-restricted-syntax
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0 hide');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          <div class="v-application  v-application--is-ltr theme--light">
            <div class="v-application--wrap">     
              <div>        
                ${prtHtml}
              </div>
            </div>
          </div>
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
  },
};
</script>

<style lang="scss" scoped>

@media print {
  .pageHeaderBox-item-printBtn {
    display: none !important;
  }
}

.pageHeaderBox {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.pageHeaderBox-title {
  text-align: center;
  margin-bottom: 1.5rem;
}

.pageHeaderBox-contain {

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.pageHeaderBox-contain-group {

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}

.pageHeaderBox-item-group {
  margin-right: 2.5rem;
  margin-bottom: 0.5rem;

  label {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
}

.pageHeaderBox-item-printBtn {
  display: none;

  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
